// DTF print & press and DTG print-only pages: instant price calculators, size guide highlight and order-form sync.
// Pricing order is fixed (web plan p.4): tier by quantity -> 1st location -> 2nd location at a discount -> rush last.
// Rush is applied per location line (then summed) so the page matches the cart variants to the cent.
(function () {
  var TIERS = [12, 25, 50, 100, 250];

  function cents(n) { return Math.round(n * 100) / 100; }
  function tierOf(qty) {
    for (var i = TIERS.length - 1; i >= 0; i--) if (qty >= TIERS[i]) return i;
    return -1; // 1-11 pieces: flat price
  }

  // locs: [{ prices: [5 numbers] }, ...] (first is required); cfg: { flat, discount, rush } as fractions.
  function quote(qty, locs, rush, cfg) {
    if (!(qty >= 1) || !locs.length) return null;
    var t = tierOf(qty), per = 0;
    var lines = locs.map(function (loc, i) {
      var price = t < 0 ? cfg.flat : loc.prices[t];
      if (i > 0) price = cents(price * (1 - cfg.discount));
      if (rush) price = cents(price * (1 + cfg.rush));
      per += price;
      return price;
    });
    return { tier: t, lines: lines, per: cents(per), total: cents(per * qty) };
  }

  // DTG print only (price list Oct 2026): each print is priced by its own row (size + sides + garment color)
  // at the tier for the total quantity; prints add up, rush is applied last. Below the minimum there is no price.
  var DTG_TIERS = [12, 25, 50, 100];
  function dtgQuote(qty, rows, rush, cfg) {
    if (!(qty >= cfg.min) || !rows.length) return null;
    var t = 0;
    for (var i = DTG_TIERS.length - 1; i >= 0; i--) if (qty >= DTG_TIERS[i]) { t = i; break; }
    var lines = rows.map(function (r) { return r.prices[t]; });
    var per = lines.reduce(function (a, b) { return a + b; }, 0);
    if (rush) per = cents(per * (1 + cfg.rush));
    return { tier: t, lines: lines, per: cents(per), total: cents(per * qty) };
  }

  var api = { quote: quote, tierOf: tierOf, dtgQuote: dtgQuote };
  if (typeof module !== 'undefined') { module.exports = api; return; }
  if (window.EonPress) return; // both page sections include this script
  window.EonPress = api;

  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function initCalc(root) {
    var cfg = { flat: +root.dataset.flat, discount: +root.dataset.discount / 100, rush: +root.dataset.rush / 100 };
    var tierLabels = JSON.parse(root.dataset.tierLabels);
    var $ = function (s) { return root.querySelector(s); };
    var qtyEl = $('[data-qty]'), rushEl = $('[data-rush]'), go = $('[data-go]');
    var sizes = root.querySelectorAll('select[data-size]'), places = root.querySelectorAll('[data-place]');

    function update() {
      var qty = qtyEl.value === '' ? 0 : Math.floor(+qtyEl.value);
      var chosen = [];
      sizes.forEach(function (sel, i) {
        var opt = sel.selectedOptions[0];
        places[i].disabled = !opt || opt.value === '';
        if (places[i].disabled) return;
        chosen.push({ name: opt.dataset.name, prices: opt.dataset.prices.split(',').map(Number), place: places[i].value, index: +opt.value });
      });
      var q = quote(qty, chosen, rushEl.checked, cfg);
      go.classList.toggle('is-disabled', !q);
      go.setAttribute('aria-disabled', String(!q));
      $('[data-tier]').textContent = q ? (q.tier < 0 ? 'Small order · 1–11 pcs' : tierLabels[q.tier] + ' pcs price tier') : '';
      $('[data-total]').textContent = q ? money(q.total) : '—';
      $('[data-per]').textContent = q ? money(q.per) + ' per piece × ' + qty + (rushEl.checked ? ' · rush included' : '') : root.dataset.emptyText;
      $('[data-lines]').innerHTML = q ? chosen.map(function (c, i) {
        return '<li>' + c.name + ' · ' + c.place + ': ' + money(q.lines[i]) + (i > 0 ? ' (' + Math.round(cfg.discount * 100) + '% off)' : '') + '</li>';
      }).join('') : '';
      document.querySelectorAll('[data-guide-size]').forEach(function (el) {
        el.classList.toggle('is-active', chosen.some(function (c) { return c.index === +el.dataset.guideSize; }));
      });
      document.dispatchEvent(new CustomEvent('eon:press-quote', { detail: {
        qty: qty, rush: rushEl.checked, quote: q,
        summary: q ? chosen.map(function (c, i) { return c.name + ' on ' + c.place + ' (' + money(q.lines[i]) + ')'; }) : [],
        perText: q ? money(q.per) : '', totalText: q ? money(q.total) : ''
      } }));
    }
    var variantsEl = root.querySelector('[data-order-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    go.addEventListener('click', function (e) {
      if (go.classList.contains('is-disabled')) { e.preventDefault(); qtyEl.focus(); return; }
      if (variants.length) { e.preventDefault(); addToCart(); }
    });

    function fail(msg) { var el = $('[data-error]'); el.textContent = msg; el.hidden = !msg; }

    // Each print location is its own cart line (variant Location / Size / Quantity tier) tied by _press_order.
    function addToCart() {
      fail('');
      var qty = Math.floor(+qtyEl.value);
      var t = tierOf(qty);
      var tierValue = t < 0 ? '1–11' : tierLabels[t];
      var lines = [];
      var missing = '';
      sizes.forEach(function (sel, i) {
        var opt = sel.selectedOptions[0];
        if (!opt || opt.value === '') return;
        var file = root.querySelectorAll('[data-art]')[i].files[0];
        if (!file) missing = missing || 'Upload the artwork for the ' + (i ? 'second' : 'first') + ' print location.';
        // Location option values match eon-dtf-press-order.csv
        var loc = rushEl.checked ? (i ? 'Second' : 'First') + ' · Rush' : (i ? 'Second (30% off)' : 'First');
        var v = variants.filter(function (x) { return x.options[0] === loc && x.options[1] === opt.dataset.name && x.options[2] === tierValue; })[0];
        lines.push({ variant: v, file: file, place: places[i].value, name: opt.dataset.name, size: opt.dataset.dims });
      });
      var garments = $('[data-garments]').value.trim();
      if (missing) return fail(missing);
      if (!garments) { $('[data-garments]').focus(); return fail('Tell us the garment type and color.'); }
      if (!$('[data-terms]').checked) return fail('Please accept the garment terms.');
      if (lines.some(function (l) { return !l.variant; })) return fail('This combination can\'t be ordered online. Please contact us.');

      var order = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var added = [];
      var label = go.textContent;
      go.classList.add('is-disabled');
      go.textContent = 'Uploading artwork…';
      var chain = Promise.resolve();
      lines.forEach(function (l, i) {
        chain = chain.then(function () {
          var fd = new FormData();
          fd.append('id', l.variant.id);
          fd.append('quantity', qty);
          fd.append('properties[_press_order]', order);
          fd.append('properties[Placement]', l.place + ' · ' + l.name + ' (' + l.size + ')');
          fd.append('properties[Artwork]', l.file, l.file.name);
          if (i === 0) {
            fd.append('properties[Garments (you supply)]', garments);
            fd.append('properties[Accepted terms]', 'Spare garments / reprint policy');
          }
          return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); added.push(j.key); }); });
        });
      });
      chain.then(function () {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function (err) {
        // Take back lines from this attempt, so the cart never holds half an order.
        var undo = added.length ? fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: added.reduce(function (u, k) { u[k] = 0; return u; }, {}) })
        }).catch(function () {}) : Promise.resolve();
        undo.then(function () { fail(err.message || 'Something went wrong. Please try again.'); go.classList.remove('is-disabled'); go.textContent = label; });
      });
    }

    root.addEventListener('input', update);
    root.addEventListener('change', update);
    document.addEventListener('eon:press-set-rush', function (e) { if (rushEl.checked !== e.detail) { rushEl.checked = e.detail; update(); } });
    update();
  }

  function initDtg(root) {
    var cfg = { min: +root.dataset.min, rush: +root.dataset.rush / 100 };
    var rows = JSON.parse(root.querySelector('[data-dtg-rows]').textContent);
    var tierLabels = JSON.parse(root.dataset.tierLabels);
    var $ = function (s) { return root.querySelector(s); };
    var qtyEl = $('[data-qty]'), rushEl = $('[data-rush]'), go = $('[data-go]'), printEl = $('[data-print]'), pocketEl = $('[data-pocket]');

    function update() {
      var qty = qtyEl.value === '' ? 0 : Math.floor(+qtyEl.value);
      var garment = ($('[name="dtg-garment"]:checked') || {}).value || 'white';
      var gLabel = garment === 'white' ? 'white garment' : 'dark/color garment';
      var chosen = [];
      var missing = false;
      function add(name, key) { var p = (rows[key] || {})[garment]; if (p) chosen.push({ name: name, prices: p }); else missing = true; }
      if (printEl.value) add(printEl.selectedOptions[0].textContent, printEl.value);
      if (pocketEl.checked) add(pocketEl.dataset.label, 'pocket');
      var q = missing ? null : dtgQuote(qty, chosen, rushEl.checked, cfg); // a print without a price row is quoted by hand
      go.classList.toggle('is-disabled', !q);
      go.setAttribute('aria-disabled', String(!q));
      $('[data-tier]').textContent = q ? tierLabels[q.tier] + ' pcs price tier' : '';
      $('[data-total]').textContent = q ? money(q.total) : '—';
      $('[data-per]').textContent = q ? money(q.per) + ' per garment × ' + qty + (rushEl.checked ? ' · rush included' : '')
        : (!chosen.length ? root.dataset.noPrintText : root.dataset.emptyText);
      $('[data-lines]').innerHTML = q ? chosen.map(function (c, i) { return '<li>' + c.name + ' · ' + gLabel + ': ' + money(q.lines[i]) + '</li>'; }).join('') : '';
      document.dispatchEvent(new CustomEvent('eon:press-quote', { detail: {
        qty: qty, rush: rushEl.checked, quote: q,
        summary: q ? chosen.map(function (c, i) { return c.name + ', ' + gLabel + ' (' + money(q.lines[i]) + ')'; }) : [],
        perText: q ? money(q.per) : '', totalText: q ? money(q.total) : ''
      } }));
    }
    go.addEventListener('click', function (e) { if (go.classList.contains('is-disabled')) { e.preventDefault(); qtyEl.focus(); } });
    root.addEventListener('input', update);
    root.addEventListener('change', update);
    document.addEventListener('eon:press-set-rush', function (e) { if (rushEl.checked !== e.detail) { rushEl.checked = e.detail; update(); } });
    update();
  }

  function initOrder(form) {
    var $ = function (s) { return form.querySelector(s); };
    var submit = $('[data-submit]'), rushEl = $('[data-order-rush]'), last = null;
    var quoteText = form.closest('section').querySelector('[data-quote-text]'); // sits beside the form
    document.addEventListener('eon:press-quote', function (e) {
      var d = e.detail; last = d;
      $('[data-f-qty]').value = d.qty || '';
      $('[data-f-prints]').value = d.summary.join('; ');
      $('[data-f-per]').value = d.perText;
      $('[data-f-total]').value = d.totalText;
      $('[data-f-rush]').value = d.rush ? 'Yes (+50%)' : 'No';
      rushEl.checked = d.rush;
      quoteText.innerHTML = d.quote
        ? '<strong>' + d.qty + ' pcs · ' + d.totalText + '</strong><br>' + d.summary.join('<br>') + (d.rush ? '<br>Rush (+50%)' : '')
        : form.dataset.emptyText;
      submit.disabled = !d.quote;
    });
    rushEl.addEventListener('change', function () { document.dispatchEvent(new CustomEvent('eon:press-set-rush', { detail: rushEl.checked })); });
    form.querySelectorAll('[name="contact[Delivery]"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var ship = $('[name="contact[Delivery]"]:checked').value === 'Ship';
        $('[data-address]').hidden = !ship;
        $('[data-address] textarea').required = ship;
      });
    });
    form.addEventListener('submit', function (e) { if (!last || !last.quote) e.preventDefault(); });
  }

  function init() {
    // Order form listens first so it receives the calculator's initial quote.
    document.querySelectorAll('[data-eon-press-order]').forEach(function (el) { if (!el.__eon) { el.__eon = 1; initOrder(el); } });
    document.querySelectorAll('[data-eon-press-calc]').forEach(function (el) { if (!el.__eon) { el.__eon = 1; initCalc(el); } });
    document.querySelectorAll('[data-eon-dtg-calc]').forEach(function (el) { if (!el.__eon) { el.__eon = 1; initDtg(el); } });
    // Full price list starts open on desktop, folded on phones (plan: fold instead of side-scroll).
    document.querySelectorAll('[data-press-table]').forEach(function (d) { if (matchMedia('(min-width: 750px)').matches) d.open = true; });
  }
  // The order form sits below the calculator, so wait for the whole page.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
